import styled from 'styled-components';

export const InvestmentVehicleCardStyles = styled.div`
	padding: 0.5rem;

	.loans {
		margin-top: 0.5rem;
	}
`;
